import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "Notice that these filters are just valid for a fixed position and orientation of the listener. Small movements (e.g. rotation) by the listener lead to invalid cancellation filters. If the position and the orientation of the listener is detected by motion tracking, the filters can be updated accordingly.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-6.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
